import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead, rapportJsonLd } from "@/lib/seo";
import { RapportPage } from "@/pages/rapport";

export const Route = createFileRoute("/$lang/sample-report")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "en";
    const t = i18n.getFixedT(lang, "rapport");
    return pageHead({
      lang,
      pathWithoutLang: "/rapport",
      title: t("seo.title"),
      description: t("seo.description"),
      jsonLd: rapportJsonLd(lang),
    });
  },
  component: RapportPage,
});
